import { IBuilderInfo } from '../../types/newbuilding';
import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectBuilderInfo = (state: IApplicationState): IBuilderInfo | undefined => {
  const { builderInfo } = selectNewbuilding(state);

  return builderInfo;
};
